module.exports = ".alignClose {\n  margin-top: 1em; }\n\n#wrapper {\n  display: flex;\n  flex-wrap: wrap; }\n"